import React, { useEffect, useState, } from 'react';
import { ButtonSizeDLS, ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { Platform, TouchableOpacity, View, } from 'react-native';
import { Typography } from '../../typography/Typography';
import CustomHeader from '../../customHeader/CustomHeader';
import NeedHelpDC from '../NeedHelpDC';
import { Icon } from '../../icon/Icon';
import { Button } from '../../button/Button';
import { addCommasToNumber, getDateMonthYearFromEpochFromMicroseconds, } from '../utils';
const MFCFetchAnchor = ({ height, contactUsDetails, refreshPortfolioAction, setCreditLimitAction, viewYourMutualFundsAction, goBackAction, triggerAction, pledgeLimitResponse, isFromEnhanceLimit, pledgeDetails, }) => {
    const availableCreditAmount = pledgeLimitResponse?.stepResponseObject
        ?.availableCreditAmount;
    const lastFetchedDate = pledgeLimitResponse?.stepResponseObject
        ?.repositoryAssetMetadataMap?.MFCENTRAL
        ?.casFetchDate;
    const totalPortfolioAmount = pledgeLimitResponse?.stepResponseObject
        ?.totalPortfolioAmount;
    const minimumCreditLimit = pledgeLimitResponse?.stepResponseObject
        ?.minimumEligibleLimit?.amount;
    const existingCreditLimit = pledgeDetails?.stepResponseObject
        ?.existingSanctionedLimit;
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [isNonEligible, setIsNonEligible] = useState(false);
    useEffect(() => {
        setIsNonEligible(availableCreditAmount < minimumCreditLimit);
    }, [pledgeDetails]);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const header = () => {
        return (React.createElement(View, null,
            React.createElement(CustomHeader, { title: '', showNeedHelpNewArch: true, needHelpAction: handleNeedHelp, goBackAction: goBackAction, triggerAction: triggerAction })));
    };
    const fundsNotEligibleBody = () => {
        return (React.createElement(View, { style: {
                marginTop: 24,
                paddingHorizontal: 16,
                paddingBottom: isFromEnhanceLimit ? 20 : 0
            } },
            isFromEnhanceLimit && existingLimitCard(),
            React.createElement(View, { style: {
                    borderRadius: 16,
                    borderWidth: 1,
                    borderColor: '#E4E7EC',
                    width: '100%',
                    padding: 16,
                    alignItems: 'center',
                    alignContent: 'center',
                    marginBottom: 8,
                } },
                React.createElement(View, { style: { marginVertical: 16 } },
                    React.createElement(Icon, { name: IconTokens.FETCH_RUPEE_ICON, size: IconSizeTokens.Size96 })),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3B, label: 'Your credit limit is low', color: ColorTokens.Grey_Night }),
                React.createElement(View, { style: {
                        marginTop: 8,
                        marginBottom: 16,
                        flexDirection: 'row',
                    } },
                    React.createElement(View, { style: { marginTop: Platform.OS !== "web" ? 0 : 4 } },
                        React.createElement(Typography, { label: '₹', fontSize: FontSizeTokens.XXXXL, color: ColorTokens.Grey_Night, fontWeight: '700', fontFamily: FontFamilyTokens.Inter })),
                    React.createElement(Typography, { label: `${addCommasToNumber(availableCreditAmount)}`, fontSize: FontSizeTokens.XXXXL, color: ColorTokens.Grey_Night, fontWeight: '700', fontFamily: FontFamilyTokens.Poppins })),
                React.createElement(View, { style: {
                        borderRadius: 8,
                        backgroundColor: '#FFEBEB',
                        padding: 12,
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        alignContent: 'center',
                    } },
                    React.createElement(Typography, { label: `A minimum credit limit of ₹${addCommasToNumber(minimumCreditLimit)} is required to apply for a loan`, typeDLS: TypographyTypeDLS.B2R, textAlign: TextAlignTokens.center, color: ColorTokens.Grey_Night }))),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'center',
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal, label: `Last fetched on ${getDateMonthYearFromEpochFromMicroseconds(lastFetchedDate)}` })),
            React.createElement(View, { style: { marginTop: 24, marginBottom: 32 } },
                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: 'Refresh portfolio', sizeDLS: ButtonSizeDLS.LARGE, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        refreshPortfolioAction &&
                            triggerAction(refreshPortfolioAction);
                    } })),
            React.createElement(TouchableOpacity, { style: {
                    borderRadius: 16,
                    borderWidth: 1,
                    backgroundColor: '#F9FAFB',
                    paddingVertical: 12,
                    paddingHorizontal: 16,
                    borderColor: '#E4E7EC',
                    justifyContent: 'center',
                }, activeOpacity: 1, onPress: () => {
                    viewYourMutualFundsAction &&
                        triggerAction(viewYourMutualFundsAction);
                } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignContent: 'center',
                        alignItems: 'center',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Fetched mutual funds', color: ColorTokens.Grey_Charcoal }),
                        React.createElement(View, { style: { marginTop: 4 } },
                            React.createElement(Typography, { label: `₹${addCommasToNumber(totalPortfolioAmount)}`, typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night }))),
                    React.createElement(Icon, { name: IconTokens.RIGHT_BLACK_ARROW, size: IconSizeTokens.LG })))));
    };
    const fundsEligibleBody = () => {
        return (React.createElement(View, { style: {
                marginTop: 24,
                paddingHorizontal: 16,
            } },
            isFromEnhanceLimit && existingLimitCard(),
            React.createElement(View, { style: {
                    borderRadius: 16,
                    borderWidth: 1,
                    borderColor: '#E4E7EC',
                    padding: 16,
                    alignItems: 'center',
                    alignContent: 'center',
                    marginBottom: 8,
                } },
                React.createElement(View, { style: { marginVertical: 16 } },
                    React.createElement(Icon, { name: IconTokens.FETCH_RUPEE_ICON, size: IconSizeTokens.Size96 })),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: isFromEnhanceLimit
                        ? 'Additional credit limit'
                        : 'Your eligible credit limit', color: ColorTokens.Grey_Night }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        marginTop: 8,
                    } },
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXXXL, fontWeight: '700', label: '₹', lineHeight: 40, color: ColorTokens.Secondary_100 }),
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.XXXXL, fontWeight: '700', lineHeight: 40, label: `${addCommasToNumber(availableCreditAmount)}`, color: ColorTokens.Secondary_100 }))),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'center',
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal, label: `Last fetched on ${getDateMonthYearFromEpochFromMicroseconds(lastFetchedDate)}` }),
                React.createElement(View, { style: { width: 8 } }),
                React.createElement(View, { style: {
                        borderBottomWidth: 1,
                        borderBottomColor: '#1434CB',
                        alignSelf: 'flex-start',
                    } },
                    React.createElement(TouchableOpacity, { activeOpacity: 1, style: {
                            flexDirection: 'row',
                            alignContent: 'center',
                            alignItems: 'center',
                        }, onPress: () => {
                            refreshPortfolioAction &&
                                triggerAction(refreshPortfolioAction);
                        } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Primary_100, label: 'Refresh' }),
                        React.createElement(View, { style: { width: 4 } }),
                        React.createElement(Icon, { name: IconTokens.REFRESH })))),
            React.createElement(View, { style: { marginTop: 24, marginBottom: 32 } },
                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: 'Set credit limit', sizeDLS: ButtonSizeDLS.LARGE, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setCreditLimitAction &&
                            triggerAction(setCreditLimitAction);
                    } })),
            React.createElement(TouchableOpacity, { style: {
                    borderRadius: 16,
                    borderWidth: 1,
                    backgroundColor: '#F9FAFB',
                    paddingVertical: 12,
                    paddingHorizontal: 16,
                    borderColor: '#E4E7EC',
                    justifyContent: 'center',
                }, activeOpacity: 1, onPress: () => {
                    viewYourMutualFundsAction &&
                        triggerAction(viewYourMutualFundsAction);
                } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignContent: 'center',
                        alignItems: 'center',
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Fetched mutual funds', color: ColorTokens.Grey_Charcoal }),
                        React.createElement(View, { style: { marginTop: 4 } },
                            React.createElement(Typography, { label: `₹${addCommasToNumber(totalPortfolioAmount)}`, typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Grey_Night }))),
                    React.createElement(Icon, { name: IconTokens.RIGHT_BLACK_ARROW, size: IconSizeTokens.LG })))));
    };
    const existingLimitCard = () => {
        return (React.createElement(View, { style: {
                borderRadius: 8,
                backgroundColor: '#F1F3F5',
                padding: 12,
                flexDirection: 'row',
                marginBottom: 16,
                alignItems: 'center',
                alignContent: 'center'
            } },
            React.createElement(Icon, { name: IconTokens.InfoIcon, size: IconSizeTokens.XL, color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: { marginLeft: 8 } },
                React.createElement(Typography, { label: `You have an existing credit limit of ₹${addCommasToNumber(existingCreditLimit)}`, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }))));
    };
    return (React.createElement(View, { style: {
            height: height,
            marginTop: -16,
            marginHorizontal: -16,
        } },
        header(),
        isNonEligible
            ? fundsNotEligibleBody()
            : fundsEligibleBody(),
        showNeedHelp && (React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails }))));
};
export default MFCFetchAnchor;
